"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _fontawesomeSvgCore = require("@fortawesome/fontawesome-svg-core");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

var _functions = require("../../util/functions");

require("./DetailsRow.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

_fontawesomeSvgCore.library.add(_freeSolidSvgIcons.faExternalLinkAlt);

var DetailsRow =
/*#__PURE__*/
function (_Component) {
  _inherits(DetailsRow, _Component);

  function DetailsRow() {
    _classCallCheck(this, DetailsRow);

    return _possibleConstructorReturn(this, _getPrototypeOf(DetailsRow).apply(this, arguments));
  }

  _createClass(DetailsRow, [{
    key: "render",
    value: function render() {
      var fund = this.props.fund;

      if (fund.stdPerformance === null) {
        return null;
      }

      var urlFilings = fund.type === 'WTETF' ? 'https://www.wisdomtree.com/resource-library/prospectus-regulatory-reports' : 'https://doc.morningstar.com/docdetail.aspx?clientid=schwab&key=84b36f1bf3830e07&cusip=' + fund.cusip;
      var stdPerformance = Array.isArray(fund.stdPerformance) ? fund.stdPerformance[0] : fund.stdPerformance;
      return _react.default.createElement("tr", {
        className: this.props.index === 0 ? 'whiteline' : 'greyline'
      }, _react.default.createElement("td", {
        className: "textLeft row-name ticker sticky"
      }, fund.ticker), _react.default.createElement("td", {
        className: "textCenter filings"
      }, _react.default.createElement("a", {
        className: "tickerLink",
        href: (0, _functions.getFundUrl)(fund),
        target: "_new"
      }, _react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        className: "link-style",
        icon: "external-link-alt"
      }))), _react.default.createElement("td", {
        className: "textCenter filings"
      }, _react.default.createElement("a", {
        className: "tickerLink",
        href: urlFilings,
        target: "_new"
      }, _react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        className: "link-style",
        icon: "external-link-alt"
      }))), _react.default.createElement("td", {
        className: "textCenter category"
      }, new Date(fund.inceptionDate).toLocaleDateString()), _react.default.createElement("td", {
        className: "textCenter fees"
      }, (0, _functions.formatPercent)(fund.expenseRatioGross)), _react.default.createElement("td", {
        className: "textCenter fees"
      }, (0, _functions.formatPercent)(fund.expenseRatio)), _react.default.createElement("td", {
        className: "textCenter date"
      }, (0, _functions.formatPercent)(stdPerformance.sec30DayYieldSub)), _react.default.createElement("td", {
        className: "textCenter date"
      }, (0, _functions.formatPercent)(stdPerformance.sec30DayYieldUnSub)), _react.default.createElement("td", {
        className: "textLeft date"
      }, fund.expenseNotes));
    }
  }]);

  return DetailsRow;
}(_react.Component);

DetailsRow.propTypes = {
  /**
   * Index of row
   */
  index: _propTypes.default.number
};
var _default = DetailsRow;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/wt-react/dist/components/StandardPerformance/DetailsRow.js
// module id = 960
// module chunks = 0